import React, { useState } from 'react';
import { LegalModal } from './ui/LegalModal';
type ModalType = null | 'privacy' | 'terms';
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  const close = () => setActiveModal(null);
  return <>
      <footer className="bg-navy-950 py-12 border-t border-navy-800" data-id="element-65">
        <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col gap-8" data-id="element-66">
          {/* Top row */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 text-center md:text-left" data-id="element-67">
            <div className="text-gold-500/50 font-serif tracking-widest text-sm uppercase" data-id="element-68">
              El Código de la Riqueza Latina
            </div>

            <nav className="flex items-center gap-8 text-sm" data-id="element-69">
              <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-gold-400 transition-colors" data-id="element-70">
                Política de Privacidad
              </button>
              <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-gold-400 transition-colors" data-id="element-71">
                Términos y Condiciones
              </button>
            </nav>
          </div>

          {/* Divider */}
          <div className="h-[1px] w-full bg-navy-800" data-id="element-72" />

          {/* Bottom row */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left" data-id="element-73">
            <div className="text-xs text-gray-600 max-w-2xl" data-id="element-74">
              Descargo de responsabilidad: La información proporcionada en este
              programa es estrictamente para fines educativos y no constituye
              asesoramiento financiero, de inversión o legal. Los resultados
              pueden variar y dependen del esfuerzo individual de cada
              participante.
            </div>

            <div className="text-xs text-gray-500 shrink-0" data-id="element-75">
              &copy; 2026. Todos los derechos reservados.
            </div>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={close} title="Política de Privacidad" data-id="element-76">
        <p className="text-gold-400/70 text-xs uppercase tracking-widest" data-id="element-77">
          Última actualización: Enero 2026
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-78">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-79">
          Recopilamos información que tú nos proporcionas directamente cuando
          adquieres "El Código de la Riqueza Latina", como tu nombre y dirección
          de correo electrónico. También podemos recopilar información
          automáticamente, como datos de uso, dirección IP y tipo de navegador
          para mejorar la experiencia del usuario.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-80">
          2. Cómo Usamos Tu Información
        </h3>
        <p data-id="element-81">
          Utilizamos tu información para entregarte el contenido del programa,
          procesar pagos de manera segura, enviar actualizaciones relacionadas
          con el producto y comunicaciones educativas, y mejorar nuestros
          servicios. Nunca venderemos tu información personal a terceros.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-82">
          3. Cookies y Tecnologías de Seguimiento
        </h3>
        <p data-id="element-83">
          Utilizamos cookies y tecnologías similares para analizar tendencias,
          administrar el sitio y recopilar información demográfica. Puedes
          desactivar las cookies a través de la configuración de tu navegador,
          aunque esto puede afectar la funcionalidad del sitio.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-84">
          4. Seguridad de los Datos
        </h3>
        <p data-id="element-85">
          Implementamos medidas de seguridad razonables para proteger tu
          información personal contra el acceso no autorizado, alteración o
          destrucción. Sin embargo, ninguna transmisión por internet es 100%
          segura.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-86">5. Tus Derechos</h3>
        <p data-id="element-87">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento. También puedes solicitar la cancelación de
          comunicaciones promocionales siguiendo el enlace de cancelación
          incluido en cada correo.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-88">
          6. Cambios a Esta Política
        </h3>
        <p data-id="element-89">
          Nos reservamos el derecho de actualizar esta política de privacidad
          periódicamente. Cualquier cambio significativo será notificado a
          través de nuestro sitio web o por correo electrónico.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={close} title="Términos y Condiciones" data-id="element-90">
        <p className="text-gold-400/70 text-xs uppercase tracking-widest" data-id="element-91">
          Última actualización: Enero 2026
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-92">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-93">
          Al adquirir y acceder a "El Código de la Riqueza Latina", aceptas
          estar sujeto a estos términos y condiciones. Si no estás de acuerdo
          con alguna parte de los términos, no debes utilizar el producto.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-94">
          2. Naturaleza del Producto
        </h3>
        <p data-id="element-95">
          El Código de la Riqueza Latina es un producto educativo digital. El
          contenido tiene como único propósito brindar información general sobre
          crédito, bienes raíces, bolsa de valores y criptomonedas. No
          constituye asesoramiento financiero, legal, fiscal ni de inversión
          personalizado.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-96">
          3. Sin Garantías de Resultados
        </h3>
        <p data-id="element-97">
          No garantizamos resultados financieros específicos. Los testimonios y
          ejemplos presentados son experiencias individuales y no representan
          ningún tipo de promesa o garantía de ingresos, ganancias o resultados
          similares. Tu éxito depende exclusivamente de tu esfuerzo, disciplina
          y circunstancias personales.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-98">
          4. Propiedad Intelectual
        </h3>
        <p data-id="element-99">
          Todo el contenido, materiales, textos, gráficos, logotipos y vídeos
          son propiedad de El Código de la Riqueza Latina y están protegidos por
          las leyes de propiedad intelectual. Queda prohibida la reproducción,
          distribución o reventa del contenido sin autorización por escrito.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-100">
          5. Política de Reembolso
        </h3>
        <p data-id="element-101">
          Ofrecemos una garantía de satisfacción dentro de los primeros 7 días
          posteriores a la compra. Para solicitar un reembolso, debes
          contactarnos a través de los canales oficiales antes de que finalice
          el período de garantía. Pasado este período, no se otorgarán
          reembolsos.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-102">
          6. Limitación de Responsabilidad
        </h3>
        <p data-id="element-103">
          En ningún caso seremos responsables por daños directos, indirectos,
          incidentales o consecuentes derivados del uso o la incapacidad de uso
          del producto. El usuario asume plena responsabilidad por sus
          decisiones financieras.
        </p>

        <h3 className="text-white font-serif text-lg mt-6" data-id="element-104">
          7. Modificaciones
        </h3>
        <p data-id="element-105">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor al ser publicadas en el
          sitio web. El uso continuo del producto constituye la aceptación de
          los términos actualizados.
        </p>
      </LegalModal>
    </>;
}